import { ApiResponse } from '../types';
import { JwtApiClient } from '../client/JwtApiClient';

type GetTaxInvoicesResponse = {
  UriList: Array<string>;
};

export class TaxInvoicesClient extends JwtApiClient {
  private readonly _baseUrl: string;
  protected _refreshUrl: string | undefined | null = undefined;

  constructor({ baseUrl, refreshTokenUrl }: { baseUrl: string; refreshTokenUrl?: string }) {
    super();
    this._baseUrl = baseUrl;
    this._refreshUrl = refreshTokenUrl;
  }

  getTaxInvoices = async ({
    orderNumber,
    sellerId = 'jbhifi',
    sourceName = 'Shopify',
    sourceId,
    invoiceNumber,
  }: {
    orderNumber: string;
    sellerId?: 'jbhifi' | string;
    sourceName?: 'Shopify' | 'Online' | 'AssistedSale' | string;
    sourceId: string | number;
    invoiceNumber?: string;
  }): Promise<ApiResponse<GetTaxInvoicesResponse>> => {
    const { data, statusCode, error } = await this._fetch<GetTaxInvoicesResponse>({
      path: `${this._baseUrl}/GetTaxInvoices`,
      method: 'POST',
      body: {
        orderNumber,
        sellerId,
        invoiceNumber,
        sourceName,
        sourceId,
      },
    });

    if (error) {
      console.error('error from TaxInvoicesClient', { error, statusCode });
      return { error, statusCode };
    }

    return { data, statusCode };
  };
}
